import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import { simpleLookupConfig } from "../../../records/lookup/config/simpleLookupConfig";
import fieldHelpers from "../../../ui-formly/fieldHelpers";
import { vsLookupManagementServiceProviderName } from "../lookupManagement";

export const vsObjectName = "contractStatus";

const url = "/api/contract/ContractStatus";

export const contractStatusLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Status",
    url,
    defaultSort: "Order",
    additionalColumns: [
      ColumnDefinitionServiceName,
      (columnDefinitionService: ColumnDefinitionService) => [
        columnDefinitionService.getNumberColDef({
          field: "Order",
        }),
      ],
    ],
    additionalFields: [
      () => [
        fieldHelpers.simpleNumberField({
          key: "Order",
          required: true,
          min: 0,
        }),
      ],
    ],
  }
);
